import { useContext } from 'react';

import { HistogramValueRepresentationContext } from '../contexts/HistogramValueRepresentation.context.js';

export const useHistogramValueRepresentation = () =>
  useContext(HistogramValueRepresentationContext);
